var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "1000",
      "title": "销售订单"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "info-panel"
  }, [_c('div', {
    staticClass: "steps-block"
  }, [_c('Steps', {
    attrs: {
      "current": _vm.currentStep,
      "size": "small"
    }
  }, [_c('Step', {
    attrs: {
      "title": "下单"
    }
  }), _c('Step', {
    attrs: {
      "title": "生产"
    }
  }), _c('Step', {
    attrs: {
      "title": "运输"
    }
  }), _c('Step', {
    attrs: {
      "title": "已收货"
    }
  })], 1)], 1), _c('SecSO', {
    ref: "SecSO"
  }), _c('SecSPO', {
    ref: "SecSPO"
  }), _c('SecDelivery', {
    ref: "SecDelivery"
  })], 1), _c('div', {
    staticClass: "comment-panel"
  }, [_c('CommentPanel', {
    ref: "CommentPanel"
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }